var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div'):_c('div',[(_vm.cdutcmPortalConfig.enabled)?_c('TcmHome',{attrs:{"cdutcm-portal-config":_vm.cdutcmPortalConfig}}):_c('Home')],1)}
var staticRenderFns = []

export { render, staticRenderFns }